// ═══════════════════════════════════════════════════════════
// ARAMS UI — Badge Component
// Variants: default, success, danger, warning, info, outline, brand
// ═══════════════════════════════════════════════════════════

import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full font-medium transition-colors',
  {
    variants: {
      variant: {
        default: 'bg-surface-800 text-surface-300 border border-surface-700',
        success: 'bg-success/15 text-success border border-success/30',
        danger: 'bg-danger/15 text-danger border border-danger/30',
        warning: 'bg-warning/15 text-warning border border-warning/30',
        info: 'bg-info/15 text-info border border-info/30',
        outline: 'border border-surface-600 text-surface-400 bg-transparent',
        brand: 'bg-brand-500/15 text-brand-400 border border-brand-500/30',
      },
      size: {
        sm: 'px-2 py-0.5 text-[10px]',
        md: 'px-2.5 py-0.5 text-xs',
        lg: 'px-3 py-1 text-sm',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'md',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ variant, size, className, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant, size }), className)} {...props} />;
}

Badge.displayName = 'Badge';
export { badgeVariants };
